import { render, staticRenderFns } from "./teamAvarters.vue?vue&type=template&id=d1d8c234"
import script from "./teamAvarters.vue?vue&type=script&lang=js"
export * from "./teamAvarters.vue?vue&type=script&lang=js"
import style0 from "./teamAvarters.vue?vue&type=style&index=0&id=d1d8c234&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports